import type { Mode } from '../types';

export interface EqBand {
  type: BiquadFilterType;
  frequency: number;
  Q: number;
  gainDb: number;
}

export type EqCurve = readonly EqBand[];

export const DEFAULT_EQ_CURVE: EqCurve = [
  { type: 'lowshelf', frequency: 250, Q: 0.707, gainDb: -3 },
  { type: 'peaking', frequency: 1000, Q: 1.0, gainDb: 0 },
  { type: 'peaking', frequency: 2000, Q: 1.0, gainDb: 6 },
  { type: 'peaking', frequency: 3500, Q: 1.0, gainDb: 9 },
  { type: 'highshelf', frequency: 6000, Q: 0.707, gainDb: 5 },
];

export const MILD_EQ_CURVE: EqCurve = [
  { type: 'lowshelf', frequency: 250, Q: 0.707, gainDb: 0 },
  { type: 'peaking', frequency: 1000, Q: 1.0, gainDb: 0 },
  { type: 'peaking', frequency: 2000, Q: 1.0, gainDb: 3 },
  { type: 'peaking', frequency: 3500, Q: 1.0, gainDb: 5 },
  { type: 'highshelf', frequency: 6000, Q: 0.707, gainDb: 3 },
];

export const AGGRESSIVE_EQ_CURVE: EqCurve = [
  { type: 'lowshelf', frequency: 250, Q: 0.707, gainDb: -6 },
  { type: 'peaking', frequency: 1000, Q: 1.0, gainDb: 0 },
  { type: 'peaking', frequency: 2000, Q: 1.0, gainDb: 8 },
  { type: 'peaking', frequency: 3500, Q: 1.0, gainDb: 12 },
  { type: 'highshelf', frequency: 6000, Q: 0.707, gainDb: 7 },
];

export interface ModePreset {
  eq: EqCurve;
  defaultGainDb: number;
}

// Per spec §5.3. NS strength is applied separately (M3+).
export const MODE_PRESETS: Record<Mode, ModePreset> = {
  conversation: { eq: DEFAULT_EQ_CURVE, defaultGainDb: 12 },
  table: { eq: DEFAULT_EQ_CURVE, defaultGainDb: 10 },
  tv: { eq: MILD_EQ_CURVE, defaultGainDb: 6 },
  noisy: { eq: AGGRESSIVE_EQ_CURVE, defaultGainDb: 8 },
};

export const COMPRESSOR_PRESET = {
  thresholdDb: -28,
  ratio: 3,
  kneeDb: 12,
  attackSec: 0.008,
  releaseSec: 0.12,
  makeupGainDb: 6,
} as const;

export const HPF_PRESET = {
  frequency: 80,
  Q: 0.707,
} as const;
